import "./ui/collapsibles/buttons/collapse_all_button.coffee";
import "./ui/collapsibles/buttons/expand_all_button.coffee";
import "./ui/collapsibles/collapsible_behavior.coffee";

import "./ui/better_modals.js.coffee";
import "./ui/local_time.js.coffee";
import "./ui/modals.js.coffee";
import "./ui/tooltips.coffee";
